"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var theme_get_1 = require("@styled-system/theme-get");

var getCursor = function getCursor(props) {
  return props.as === 'span' ? 'default' : 'pointer';
};

var InnerTag = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: ", ";\n  line-height: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  text-decoration: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:not(:last-child) {\n    margin-right: ", ";\n  }\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: ", ";\n  line-height: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  text-decoration: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:not(:last-child) {\n    margin-right: ", ";\n  }\n"])), theme_get_1.themeGet('fontSizes.body.sm'), theme_get_1.themeGet('lineHeights.body.sm'), theme_get_1.themeGet('space.xs'), theme_get_1.themeGet('space.xs'), theme_get_1.themeGet('colors.text.default'), theme_get_1.themeGet('colors.background.light'), theme_get_1.themeGet('radii.sm'), getCursor, theme_get_1.themeGet('colors.neutral.20'), theme_get_1.themeGet('space.xs'));

exports.Tag = function (props) {
  return React.createElement(InnerTag, __assign({}, props));
};

exports.Tag.defaultProps = {
  as: 'span'
};
var templateObject_1;